import { CategoryActions } from '@/components/shared/category-actions';
import { Skeleton } from '@/components/ui/app-skeleton';
import { cn } from '@/lib/ui/utils';

export function ListingDiscoveryActionsSkeleton(): React.ReactNode {
  return (
    <>
      <CategoryActions loading>
        <div aria-hidden className="flex items-center gap-2">
          <LabeledActionSkeleton className="w-28" />
          <LabeledActionSkeleton className="w-21" />
          <Skeleton className="h-9 w-36 rounded-control" />
        </div>
      </CategoryActions>
      <div aria-hidden className="flex shrink-0 items-center gap-0">
        <IconActionSkeleton className="lg:hidden" />
        <IconActionSkeleton />
        <IconActionSkeleton className="lg:hidden" />
      </div>
    </>
  );
}

export function IconActionSkeleton({ className }: { className?: string }): React.ReactNode {
  return (
    <div aria-hidden className={cn('flex size-9 shrink-0 items-center justify-center', className)}>
      <Skeleton className="size-4 rounded-full" />
    </div>
  );
}

function LabeledActionSkeleton({ className }: { className: string }): React.ReactNode {
  return (
    <div className={cn('flex h-9 items-center gap-2 px-3', className)}>
      <Skeleton className="size-4 shrink-0 rounded-full" />
      <Skeleton className="h-4 flex-1 rounded-item" />
    </div>
  );
}
